export interface RpsScope {
  mode: "all" | "attributes" | "unconfigured"
  attributeIds: string[]
}

export function addRpsSuggestions(scope: RpsScope, ids: unknown, allowed: Set<string>): RpsScope {
  if (scope.mode === "all" || !Array.isArray(ids)) return scope
  const additions = ids.filter((id): id is string => typeof id === "string" && allowed.has(id))
  const attributeIds = [...new Set([...scope.attributeIds, ...additions])]
  return attributeIds.length ? { mode: "attributes", attributeIds } : scope
}
